// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"728":"c9a31724","770":"71c8862d"}[chunkId] + ".chunk.css";
};